<template>
    <div class="block-content summary-totals" :class="{'desktop': desktop}">
        <div class="price" style="font-size: 1.2em;">
            Total
        </div>
        <div class="price" style="font-weight: normal;">
            <div>Subtotal</div>
            <div>{{ formatMoney(totalPrice) }}</div>
        </div>
        <div class="price">
            <div>
                <b-form-radio v-model="parcialPayAux" :value="false">Pagar 100% del pedido</b-form-radio>
            </div>
            <div>{{ formatMoney(totalPrice) }}</div>
        </div>
        <div class="price parcial">
            <div>
                <b-form-radio v-model="parcialPayAux" :value="true">Pagar un porcentaje del pedido</b-form-radio>
                <div v-show="parcialPayAux">
                    <div style="font-weight: normal; margin: 1rem 0">
                        Babyplant te recordará una semana antes de la entrega que pagues el resto.
                    </div>
                    <div style="display: flex; font-size: 0.9em; align-items: flex-end">
                        <div>
                            Ahora
                            <b-input-group style="width: 5rem">
                                <b-input-group-prepend>
                                    <b-button @click="less" class="c-btn-parcial-plus left">-</b-button>
                                </b-input-group-prepend>
                                <b-form-input :value="parcialPayPercentAux + '%'" class="c-parcial-input" readonly></b-form-input>
                                <b-input-group-append>
                                    <b-button @click="more" class="c-btn-parcial-plus right">+</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                        <div style="margin-left: 5px; flex: 0 0 8rem">
                            <span>Antes de la entrega</span>
                            <b-form-input :value="parcialPayPercentLate + '%'" style="width: 4rem;text-align: center" readonly></b-form-input>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="parcialPayAux" style="align-self: flex-end;">{{ formatMoney(parcialPayTotal) }}</div>
        </div>
        <div class="price">
            <div>Total <span style="font-weight: normal">(Iva incluido)</span></div>
            <div>{{ formatMoney(parcialPayTotal) }}</div>
        </div>
        <slot name="after-total"></slot>
        <div>
            <button class="btn c-btn-summary next" :disabled="goingCart" @click="$emit('go-cart')">
                Tramitar pedido
            </button>
        </div>
        <div>
            <button @click="goMore" class="btn c-btn-summary more">
                Seguir comprando
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SummaryTotals",
        props: {
            totalPrice: {
                type: Number
            },
            parcialPayPercent: {
                type: Number,
                default: 50
            },
            minPercent: {
                type: Number,
                default: 50
            },
            desktop: {
                type: Boolean,
                default: false
            },
            goingCart: {
                type: Boolean
            }
        },
        data() {
            return {
                parcialPayPercentAux: 50,
                stepPercent: 5,
            }
        },
        computed: {
            parcialPayAux: {
                set(value) {
                    if (value) {
                        this.parcialPayPercentAux = this.minPercent;
                    } else {
                        this.parcialPayPercentAux = 100;
                    }
                    this.changedParcialPayPercentInput();
                },
                get() {
                    return this.parcialPayPercentAux !== 100;
                }
            },
            parcialPayPercentLate() {
                return 100 - this.parcialPayPercentAux;
            },
            parcialPayTotal() {
                return this.parcialPayPercentAux / 100 * this.totalPrice;
            }
        },
        watch: {
            parcialPay(value) {
                this.changedParcialPay();
            },
            parcialPayPercent() {
                this.changedParcialPayPercent();
            }
        },
        methods: {
            goMore() {
                this.$emit('go-more', 'ok');
            },
            more() {
                if (this.parcialPayPercentAux <= (100 - this.stepPercent)) {
                    this.parcialPayPercentAux += this.stepPercent;
                    this.changedParcialPayPercentInput();
                }
            },
            less() {
                if (this.parcialPayPercentAux >= this.stepPercent &&
                    this.parcialPayPercentAux - this.stepPercent >= this.minPercent) {
                    this.parcialPayPercentAux -= this.stepPercent;
                    this.changedParcialPayPercentInput();
                }
            },
            changedParcialPayPercent() {
                this.parcialPayPercentAux = this.parcialPayPercent
            },
            changedParcialPayPercentInput() {
                this.$emit('update:parcialPayPercent', this.parcialPayPercentAux);
            }
        },
        created() {
            this.changedParcialPayPercent();
        }
    }
</script>

<style scoped>

    .summary-totals.desktop {
        display: none;
    }

    .summary-totals .price {
        display: flex;
        justify-content: space-between;
        padding-bottom: 1rem;
        font-weight: bold;
        border-top: 1px solid #cbc8c8;
        padding-top: 1rem;
        text-align: left;
    }

    .summary-totals .price:first-child, .summary-totals .price.parcial {
        border-top: none;
        padding-top: 0;
    }

    .c-btn-summary {
        font-size: 17px;
        width: 100%;
        font-weight: bold;
        padding: 5px;
        margin-top: 10px;
        border-width: 2px;
        border-radius: 0;
        margin-bottom: 0.5em;
        max-width: 250px;
    }

    .c-btn-summary.next {
        color: #ffffff;
        background-color: #ff3366;
        border-color: #db2d49;
    }

    .c-btn-summary.more {
        color: #0071bc;
        background-color: #fec82f;
        border-color: #0071bc;
    }

    .c-btn-summary.next:hover {
        background-color: #db2d49;
    }

    .c-btn-summary.more:hover {
        background-color: #f29020;
    }

    .c-btn-summary.next:disabled, .c-btn-summary.more:disabled {
        background-color: #b4b3b3;
        color: #808081;
        border-color: #808081;
        opacity: 1;
    }

    .c-btn-parcial-plus {
        background-color: #fbc531;
        color: #5b5b5c;
        font-weight: bold;
        border-color: #cbc8c9;
        padding: 0.375rem 0.5rem;
        flex: 1 1 auto;
    }

    .c-parcial-input {
        text-align: center;
        padding-left: 0;
        padding-right: 0;
        font-weight: bold;
    }

    .c-btn-parcial-plus.left {
        border-right: 0;
    }

    .c-btn-parcial-plus.right {
        border-left: 0;
    }

    @media (min-width: 575px) {
        .c-btn-summary.next {
            margin-bottom: 0.2rem;
        }

        .c-btn-summary.more {
            margin-bottom: 2rem;
        }
    }

    @media (min-width: 992px) {
        .summary-totals {
            display: none;
        }

        .summary-totals.desktop {
            display: block;
            padding: 20px;
        }
    }
</style>
